<app-spinner-service></app-spinner-service>

<form [formGroup]="lancamentoFormEditar" (ngSubmit)="onSubmit()" class="form-grid">
  <fieldset class="form-fieldset">
    <legend class="form-block-legend">
      <i class="pi pi-credit-card"></i>
      Editar Lançamento de Caixa
    </legend>
    
    <div class="p-fluid p-formgrid p-grid">
      <div class="p-field p-col-12 p-md-6">
        <label for="tipo">
          Tipo <span class="required">*</span>
        </label>
        <p-dropdown 
          [options]="tipoOptions" 
          formControlName="tipo" 
          optionLabel="label" 
          optionValue="value"
          [ngClass]="{'invalid-field': lancamentoFormEditar.get('tipo')?.invalid && lancamentoFormEditar.get('tipo')?.touched}"
          placeholder="Selecione o Tipo" 
          (onChange)="onTipoChange($event)">
        </p-dropdown>
        <small *ngIf="lancamentoFormEditar.get('tipo')?.invalid && lancamentoFormEditar.get('tipo')?.touched" class="error-message">
          <i class="pi pi-exclamation-triangle"></i>
          Tipo é obrigatório.
        </small>
        <small class="field-hint">
          <i class="pi pi-info-circle"></i>
          Selecione se é recebimento ou pagamento
        </small>
      </div>

      <div class="p-field p-col-12 p-md-6">
        <label for="periodo">
          Data <span class="required">*</span>
        </label>
        <p-calendar 
          id="periodo" 
          formControlName="periodo" 
          dateFormat="dd/mm/yy"
          [showIcon]="true"
          [ngClass]="{'invalid-field': lancamentoFormEditar.get('periodo')?.invalid && lancamentoFormEditar.get('periodo')?.touched}"
          placeholder="Selecione a data">
        </p-calendar>
        <small *ngIf="lancamentoFormEditar.get('periodo')?.invalid && lancamentoFormEditar.get('periodo')?.touched" class="error-message">
          <i class="pi pi-exclamation-triangle"></i>
          Data é obrigatória.
        </small>
        <small class="field-hint">
          <i class="pi pi-info-circle"></i>
          Data do lançamento
        </small>
      </div>

      <div class="p-field p-col-12 p-md-6">
        <label for="valor">
          Valor <span class="required">*</span>
        </label>
        <p-inputNumber 
          id="valor" 
          formControlName="valor" 
          mode="currency" 
          currency="BRL"
          locale="pt-BR"
          [minFractionDigits]="2"
          [maxFractionDigits]="2"
          [ngClass]="{'invalid-field': lancamentoFormEditar.get('valor')?.invalid && lancamentoFormEditar.get('valor')?.touched}"
          placeholder="0,00">
        </p-inputNumber>
        <small *ngIf="lancamentoFormEditar.get('valor')?.invalid && lancamentoFormEditar.get('valor')?.touched" class="error-message">
          <i class="pi pi-exclamation-triangle"></i>
          Valor é obrigatório e deve ser positivo.
        </small>
        <small class="field-hint">
          <i class="pi pi-info-circle"></i>
          Valor do lançamento
        </small>
      </div>

      <div class="p-field p-col-12 p-md-6">
        <label for="descricao">
          Descrição <span class="required">*</span>
        </label>
        <input 
          pInputText 
          id="descricao" 
          formControlName="descricao"
          [ngClass]="{'invalid-field': lancamentoFormEditar.get('descricao')?.invalid && lancamentoFormEditar.get('descricao')?.touched}"
          placeholder="Descreva o lançamento">
        <small *ngIf="lancamentoFormEditar.get('descricao')?.invalid && lancamentoFormEditar.get('descricao')?.touched" class="error-message">
          <i class="pi pi-exclamation-triangle"></i>
          Descrição é obrigatória.
        </small>
        <small class="field-hint">
          <i class="pi pi-info-circle"></i>
          Descreva detalhadamente o lançamento
        </small>
      </div>

      <div class="p-field p-col-12">
        <label for="contaContabilId">
          Conta Contábil <span class="required">*</span>
        </label>
        <p-dropdown 
          [options]="contaContabilOptions" 
          formControlName="contaContabilId" 
          optionLabel="descricao"
          [ngClass]="{'invalid-field': lancamentoFormEditar.get('contaContabilId')?.invalid && lancamentoFormEditar.get('contaContabilId')?.touched}"
          placeholder="Selecione uma Conta Contábil" 
          [disabled]="true">
        </p-dropdown>
        <small *ngIf="lancamentoFormEditar.get('contaContabilId')?.invalid && lancamentoFormEditar.get('contaContabilId')?.touched" class="error-message">
          <i class="pi pi-exclamation-triangle"></i>
          Conta Contábil é obrigatória.
        </small>
        <small class="field-hint">
          <i class="pi pi-info-circle"></i>
          Conta contábil relacionada (não pode ser alterada)
        </small>
      </div>
    </div>
  </fieldset>

  <div class="form-actions">
    <p-button label="Voltar" icon="pi pi-chevron-left" (click)="retornar()" severity="secondary"></p-button>
    <p-button type="submit" label="Salvar Alterações" icon="pi pi-check" [disabled]="lancamentoFormEditar.invalid" class="p-button-primary"></p-button>
  </div>
</form>